import styled from 'styled-components'

import { CommentItemSkeleton } from '@root/entities/comment/ui'
import { Skeleton } from '@root/shared/ui-kit'

export const CommentsHistorySkeleton = () => {
  return (
    <Root>
      <Header>
        <Skeleton width={30} height={30} variant="circular" />
        <Skeleton width={160} height={14} />
        <Skeleton width={120} height={14} />
      </Header>
      <Thread>
        <CommentItemSkeleton />
      </Thread>
    </Root>
  )
}

const Root = styled.div`
  background: var(--background-2);
  z-index: 0;

  border-radius: 10px;
  padding: 2px;
`

const Header = styled.div`
  background: var(--backgroundA-2);

  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;

  height: 42px;
  border-radius: 8px;
  padding-inline: 8px;
  gap: 10px;
`

const Thread = styled.div`
  padding: 12px;
  padding-bottom: 10px;
`
